import { TruckLane } from '../dtos/truck-lane';
import { CarrierLanesTable } from '../views/carrier-lanes-table';
import { IS_NOT_EMPTY } from '../../utils/stringUtils/string-utils';
import { IS_NOT_NULL_OR_UNDEFINED } from './../../utils/commonUtils/validation-utils';
import { GET_LANE_FREQUENCY } from './broker-lane-details-table';
import { DATE_MDY } from '../../utils/date';

export const CARRIER_LANES_LIST_TABLE = (
	lanesList: Array<TruckLane> = []
): Array<CarrierLanesTable> => {
	let results: Array<CarrierLanesTable> = [];
	try {
		if (lanesList.length > 0) {
			lanesList.map((lane) => {
				let row = {} as CarrierLanesTable;
				row.origin =
					(IS_NOT_EMPTY(lane.originCity) ? lane.originCity + ', ' : '') +
					(IS_NOT_EMPTY(lane.originState) ? lane.originState : '');
				if (IS_NOT_EMPTY(lane.destCity)) {
					row.destination = lane.destCity;
					if (IS_NOT_EMPTY(lane.destState)) {
						row.destination += ', ' + lane.destState;
					}
				} else if (IS_NOT_EMPTY(lane.destState)) {
					row.destination = lane.destState;
				} else {
					row.destination = '';
				}
				row.originMetadata = {
					latitude: IS_NOT_NULL_OR_UNDEFINED(lane.originLat) ? Number(lane.originLat) : null,
					longitude: IS_NOT_NULL_OR_UNDEFINED(lane.originLng) ? Number(lane.originLng) : null,
					zip: lane.originZip,
					country: lane.originCountry,
				};
				row.carrierId = lane.carrierId;
				row.trailerType = lane.trailerType;
				row.confirmationDate = lane.confirmationDate
					? new Date(DATE_MDY(lane.confirmationDate))
					: null;
				row.backhaulAvailable = lane.hasBackhaulLane;
				if (row.destination.length == 0 && IS_NOT_EMPTY(lane.destinationStates)) {
					row.destination = null;
					row.destinationStates = lane.destinationStates.split(',');
				}
				row.destinationMetadata = {
					latitude: IS_NOT_NULL_OR_UNDEFINED(lane.destLat) ? Number(lane.destLat) : null,
					longitude: IS_NOT_NULL_OR_UNDEFINED(lane.destLng) ? Number(lane.destLng) : null,
					zip: lane.destZip,
					country: lane.destCountry,
				};
				row.id = lane.id;
				row.weeklyFrequency = lane.weeklyFrequency != null ? lane.weeklyFrequency : 1;
				row.runDaily = lane.runDaily != null ? lane.runDaily : false;
				row.monday = lane.monday != null ? lane.monday : false;
				row.tuesday = lane.tuesday != null ? lane.tuesday : false;
				row.wednesday = lane.wednesday != null ? lane.wednesday : false;
				row.thursday = lane.thursday != null ? lane.thursday : false;
				row.friday = lane.friday != null ? lane.friday : false;
				row.saturday = lane.saturday != null ? lane.saturday : false;
				row.sunday = lane.sunday != null ? lane.sunday : false;

				row.truckLaneId = lane.truckLaneId;
				row.age = lane.age;
				row.carrierLaneId = lane.carrierLaneId;
				row.destinationDeadhead = lane.destinationDeadhead;
				row.frequency = GET_LANE_FREQUENCY(lane);
				row.fromCarrier = lane.fromCarrier;
				row.toBeReviewed = lane.toBeReviewed;
				row.originDeadheadLimit = lane.originDeadheadLimit;
				row.destinationDeadheadLimit = lane.destinationDeadheadLimit;
				row.ltl = lane.ltl;

				results.push(row);
			});
		}
	} catch (error) {
		console.log('CARRIER_LANES_LIST_TABLE error: ', error);
	}
	return results;
};
